import type { Language } from "@/data/model/Enums";
import type { ICurrentIdentityService } from "@/data/services/CurrentIdentityService";

import { clientLanguage } from "@/shared/localization/language";

import { TastierClient } from "@/app/TastierClient";

export class AppCurrentIdentityService implements ICurrentIdentityService {
    public getIdentityId(): string | undefined {
        return TastierClient?.identityContext?.getIdentityId();
    }

    public getLanguage(): Language {
        return clientLanguage();
    }
}
